import React from 'react'
import '../Styles/Section5.css'

export default function Section5() {
  // const sec5learnmorenavigatehandler = (sectionid)=>{
  //   window.location.href = `/courses#${sectionid}`;
  // }
  const sec5learnmorenavigatehandler = ()=>{
    window.location.href = `/courses`;
  }
  return (
    <div className='section5'>
        <div className="sec5container">
            <div className="sec5head">COURSES</div>
            <ul className="accordion">
              <li>
                <input type="radio" name='accordion' id='first' />
                <label htmlFor="first">BA</label>
                <div className="content">
                  <p>B.A ( BACHELOR OF ART ) IS A 3 YEAR COURSE. WE ARE PROVIDING THIS IN ECONOMICS , GEOGRAPHY , EDUCATION , HISTORY AND POLITICAL SCIENCE <br/>COURSE DURATION – 3 YEARS(6 SEMESTERS) <br/>FEE STRUCTURE – 6000/YEAR</p>
                  <div className="sec5btn" onClick={sec5learnmorenavigatehandler}>Learn More</div>
                </div>
              </li>
              <li>
                <input type="radio" name='accordion' id='second' />
                <label htmlFor="second">B.COM.</label>
                <div className="content">
                  <p>B.COM. ( BACHELOR IN COMMERCE ) IS A 3 YEAR COURSE. <br/>COURSE DURATION – 3 YEARS(6 SEMESTERS) <br/>FEE STRUCTURE – 7000/YEAR</p>
                  <div className="sec5btn" onClick={sec5learnmorenavigatehandler}>Learn More</div>
                </div>
              </li>
              <li>
                <input type="radio" name='accordion' id='third' />
                <label htmlFor="third">B.Ed.</label>
                <div className="content">
                  <p>B.ED ( BECHALOR OF EDUCATION )IS AN UNDERGRADUATE DEGREE THAT FOCUSES ON A BROAD KNOWLEDGE OF EDUCATIONAL THEORIES AND PRACTICE AS WELL AS THE ABILITIES REQUIRED TO BEGIN A CAREER IN TEACHING. <br/>COURSE DURATION – 2 YEAR ( 4 SEMESTER )<br/>FEE STRUCTURE – 6000/ YEAR</p>
                  <div className="sec5btn" onClick={sec5learnmorenavigatehandler}>Learn More</div>
                </div>
              </li>
              <li>
                <input type="radio" name='accordion' id='fourth' />
                <label htmlFor="fourth">B.Sc.</label>
                <div className="content">
                  <p>B.SC ( BACHELOR OF SCIENCE ) IS A 3 YEAR COURSE.WE ARE PROVIDING THIS COURSE IN CBZ( CHEMISTRY , BOTANY AND ZOOLOGY ) AND PCM ( PHYSICS , CHEMISTRY AND MATHMATICS )<br/>COURSE DURATION – 3 YEAR ( 6 SEMESTER )<br/>FEE STRUCTURE – 8500/YEAR</p>
                  <div className="sec5btn" onClick={sec5learnmorenavigatehandler}>Learn More</div>
                </div>
              </li>
              <li>
                <input type="radio" name='accordion' id='fifth' />
                <label htmlFor="fifth">M.A.</label>
                <div className="content">
                  <p>M.A. ( MASTER OF ARTS ) IS A 3 YEAR COURSE. <br/>COURSE DURATION – 3 YEAR ( 6 SEMESTER )<br/>FEE STRUCTURE – 9000/YEAR</p>
                  <div className="sec5btn" onClick={sec5learnmorenavigatehandler}>Learn More</div>
                </div>
              </li>
              <li>
                <input type="radio" name='accordion' id='sixth' />
                <label htmlFor="sixth">M.Com.</label>
                <div className="content">
                  <p>M.Com. ( MASTER OF COMMERCE ) IS A 3 YEAR COURSE.<br/>COURSE DURATION – 3 YEAR ( 6 SEMESTER )<br/>FEE STRUCTURE – 9000/YEAR</p>
                  <div className="sec5btn" onClick={sec5learnmorenavigatehandler}>Learn More</div>
                </div>
              </li>
            </ul>
        </div>
    </div>
  )
}
